import { type SocketMachineContext } from '../../../network-state-machine-context';
import { type AuthenticatedEvent } from '../../../network-state-machine-events';

export async function authenticatingAsync<
  C extends Pick<SocketMachineContext, 'accessTokenSupplier' | 'debounce'>
>(ctx: C, _signal: AbortSignal): Promise<AuthenticatedEvent> {
  const accessToken = await ctx.accessTokenSupplier();

  return {
    type: 'authenticated',
    accessToken,
  };
}
